<ng-container *ngIf="!showDetail">
    <div class="d-flex flex-row justify-content-between align-items-center mt-3">
        <div class="form-inline">
            <span class="badge badge-warning">
                <span class="material-icons">
                    badge
                </span>
            </span>
            <h4 class="mt-2">Empleados</h4>
        </div>
        <div class="btn-group" role="group">
            <button type="button" class="btn btn-info" (click)="addEmployee()">
                <span class="material-icons">
                    people
                </span>
                <span>Dar de alta empleado</span>
            </button>
        </div>
    </div>
    <div class="d-flex flex-row align-items-center mt-3">
        <div class="form-group">
            <input type="text" class="form-control" id="searchText" placeholder="Search employee"
                (keyup)="searchEmployee($event.target.value)">
        </div>
    </div>
    <div class="table-responsive" infinite-scroll (scrolled)="scrollEmployees()">
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th class="headers">
                        <span>Nombre(s)</span>
                    </th>
                    <th class="headers">
                        <span>Apellido(s)</span>
                    </th>
                    <th class="headers">
                        <span>Email</span>
                    </th>
                    <th class="headers">
                        <span>Contraseña</span>
                    </th>
                    <th class="headers">
                        <span>Teléfono</span>
                    </th>
                    <th class="headers">
                        <span>Puesto</span>
                    </th>
                    <th class="headers">
                        <span>Fecha de entrada</span>
                    </th>
                    <th class="headers">
                        <span>Descripción</span>
                    </th>
                    <th class="headers">
                        <span>Rol</span>
                    </th>
                    <th class="headers">
                        <span>Acciones</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let employee of employees">
                    <td class="cells text-break">{{employee.name}}</td>
                    <td class="cells text-break">{{employee.lastName}}</td>
                    <td class="cells text-break">{{employee.email}}</td>
                    <td class="cells text-break">{{employee.password}}</td>
                    <td class="cells text-break">{{employee.phone}}</td>
                    <td class="cells text-break">{{employee.jobName}}</td>
                    <td class="cells text-break">{{employee.entranceDate}}</td>
                    <td class="cells text-break">{{employee.description}}</td>
                    <td class="cells text-break">{{employee.role}}</td>
                    <td class="cells text-break">
                        <div class="dropdown btn-group dropup mr-1 mb-1" ngbDropdown>
                            <button type="button" class="btn btn-info">Actions</button>
                            <button type="button" class="btn btn-info dropdown-toggle" ngbDropdownToggle
                                aria-haspopup="true" aria-expanded="false">
                                <span class="sr-only">Toggle Dropdown</span>
                            </button>
                            <div ngbDropdownMenu class="dropdown-menu" role="menu">
                                <button type="button" class="btn" (click)="assignJob(employee)">
                                    <span class="material-icons">
                                        assignment_ind
                                    </span>
                                    Asignar puesto de trabajo
                                </button>
                                <div class="dropdown-divider"></div>
                                <button type="button" class="btn" (click)="editIndicators(employee)">
                                    <span class="material-icons">
                                        playlist_add
                                    </span>
                                    Editar indicadores
                                </button>
                                <div class="dropdown-divider"></div>
                                <button type="button" class="btn" (click)="viewIndicators(employee)">
                                    <span class="material-icons">
                                        settings_overscan
                                    </span>
                                    Ver indicadores
                                </button>
                                <div class="dropdown-divider"></div>
                                <button type="button" class="btn" (click)="viewIndicators(employee)">
                                    <span class="material-icons">
                                        assignment
                                    </span>
                                    Ver puntos de control
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<ng-container *ngIf="showDetail">
    <app-employee-detail [employee]="selectedEmployee" (closeDetail)="closeDetail()"></app-employee-detail>
</ng-container>